import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import {createBaseQuery} from '../../utils/apiUtils';
import GlobalConst from "../../constants/GlobalConst";
import Cookies from 'js-cookie';
import {mapAccountId} from "../../services/hub/Connection";

export const accountApi = createApi({
    reducerPath: 'accountApi', // Optional, if you want to have multiple APIs

    // todo: create a factory function to create the base query
    baseQuery: createBaseQuery(GlobalConst.TF_API.FULLURL), // Your API base URL
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (userData) => ({
                url: 'Auth/Login',
                method: 'POST',
                body: userData,
            }),
            async onQueryStarted(response, {dispatch, queryFulfilled}) {
                try {
                    const {data: {access_token}} = await queryFulfilled;
                    Cookies.set('tfsession', access_token, { domain: GlobalConst.SITE_URLS.DOMAIN, expires: 7, path: '/' });

                } catch (e) {
                    console.error('Failed to login', e);
                }
            },
        }),
        register: builder.mutation({
            query: (userData) => ({
                url: 'Auth/Register',
                method: 'POST',
                body: userData,
            }),
            async onQueryStarted(response, {dispatch, queryFulfilled}) {
                try {
                    const {data: {access_token}} = await queryFulfilled;
                    Cookies.set('tfsession', access_token, { domain: GlobalConst.SITE_URLS.DOMAIN, expires: 7, path: '/' });
                } catch (e) {
                    console.error('Failed to register', e);
                }
            }
        }),
        loginWithPrivy: builder.mutation({
            query: (privyData) => ({
                url: 'Auth/LoginWithPrivy',
                method: 'POST',
                body: privyData,
            }),
            async onQueryStarted(response, {dispatch, queryFulfilled}) {
                try {
                    const {data: {access_token}} = await queryFulfilled;
                    Cookies.set('tfsession', access_token, { domain: GlobalConst.SITE_URLS.DOMAIN, expires: 7, path: '/' });
                } catch (e) {
                    console.error('Failed to login with Privy', e);
                }
            }
        }),
        getAccount: builder.query({
            query: (token) => ({
                url: 'Accounts/Current',
                method: 'GET',
            }),
            async onQueryStarted(arg, { queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    mapAccountId(data.accountId);
                } catch (error) {
                    console.error('Failed to fetch account:', error);
                }
            },
        }),
        logOut: builder.mutation({
            query: () => ({
                url: 'Auth/Logout',
                method: 'POST',
            }),
            async onQueryStarted(response, {dispatch, queryFulfilled}) {
                try {
                    await queryFulfilled;
                    Cookies.remove('tfsession', { domain: window.location.host.split('.').splice(1,2).join('.'), path: '/' });
                    setTimeout(()=>{
                        window.location.reload();
                    },500);
                } catch (e) {
                    console.error('Failed to logout', e);
                }
            }
        }),
        updateAccount: builder.mutation({
            query: (updatedUser) => ({
                url: `Accounts/${updatedUser.accountId}`,
                method: 'PUT',
                body: JSON.stringify(updatedUser),
            })
        }),
        updateAccountDetails: builder.mutation({
            query: (updatedUser) => ({
                url: `Accounts/Details`,
                method: 'PUT',
                body: JSON.stringify(updatedUser),
            })
        }),
        updateAddress: builder.mutation({
            query: (address) => ({
                url: 'Accounts/Address',
                method: 'PUT',
                body: JSON.stringify(address),
            })
        }),
        updateAccountCulture: builder.mutation({
            query: (culture) => ({
                url: 'Accounts/Culture',
                method: 'PUT',
                body: JSON.stringify(culture),
            })
        }),
        getTransactions: builder.query({
            query: (accountId) => ({
                url: `Accounts/Transactions`,
                method: 'GET',
            })
        }),
        uploadPicture: builder.mutation({
            query: (picture) => ({
                url: 'Accounts/UploadPicture',
                method: 'POST',
                body: JSON.stringify(picture),
            })
        }),
        sendContactUs: builder.mutation({
            query: (model) => ({
                url: 'Help/ContactUs',
                method: 'POST',
                body: JSON.stringify(model),
            })
        }),
        withdrawFunds: builder.mutation({
            query: (data) => ({
                url: `Accounts/${data.accountId}/WithdrawFunds?amount=${data.amount}&currency=${data.currency}`,
                method: 'POST',
                body: JSON.stringify({accountId: data.accountId, amount: data.amount, currency: data.currency}),
            })
        }),
    }),
});

export const {
    useLoginMutation,
    useLoginWithPrivyMutation,
    useLogOutMutation,
    useGetAccountQuery,
    useLazyGetAccountQuery,
    useUpdateAccountMutation,
    useUpdateAccountCultureMutation,
    useUpdateAccountDetailsMutation,
} = accountApi; // Export hooks

export default accountApi;
